import { AboutusSection } from "./sections/aboutusSec";
import { Convince } from "./sections/Convincing";
import { OurServicesSection } from "./sections/ourservicesSection";
import { OptInSection } from "./sections/optinSec";
import { HeroSection } from "./sections/heroSec";
import { NavBar } from "./sections/NavBar";
import { ContactSheet } from "./sections/contactSheet";
import { useState, useRef, useCallback, useEffect } from "react";
import ScrollSpy from "react-ui-scrollspy";
import { useLocation } from "react-router-dom";

export const Home =()=>{

    const [showContact, setShowContact] = useState(false);
    const [inputPackageType, setInputPackageType] = useState('');
    const isProgrammaticChange = useRef(false);
    const contactSheetRef = useRef();
    const contactSheetBtnRef = useRef();
    const contactSheetBtnSecRef = useRef()



    const handlePackageType =(value)=>{
        setInputPackageType(value);
        isProgrammaticChange.current = true;

        document.getElementById('opt-in').scrollIntoView({ behavior: 'smooth' });
    }


    const handleManualChange = (value)=>{
        if (!isProgrammaticChange.current) {
            setInputPackageType(value);
        } else {
            isProgrammaticChange.current = false
        }
    }

    const handleShowContact= useCallback(()=>{
        console.log(showContact);
        setShowContact(oldValue => !oldValue);
    },[showContact])

    const handleCloseContact = (e)=>{
        if (!contactSheetRef.current.contains(e.target) && !contactSheetBtnRef.current.contains(e.target) && !contactSheetBtnSecRef.current.contains(e.target)) {
            setShowContact(false);
        }
    }

    useEffect(() => {
        console.log(showContact);
        if (showContact) {
          document.addEventListener('mousedown', handleCloseContact);
        } else {
          document.removeEventListener('mousedown', handleCloseContact);
        }
    
        return () => {
          document.removeEventListener('mousedown', handleCloseContact);
        };
      }, [showContact]);

    const location = useLocation();

    return(
        <>  
            <NavBar path={location} packFunc={handlePackageType} />

            <ScrollSpy 
                offsetTop={0}
                offsetBottom={0}
                items={['home', 'about', 'services']}
            >
                <div id="home">
                    <HeroSection />
                </div>
                <div id="about">
                    <AboutusSection func={handleShowContact} ref={contactSheetBtnRef} />
                </div>
                
                <div id='services' >
                    <OurServicesSection packFunc={handlePackageType} func={handleShowContact} ref={contactSheetBtnSecRef}/>
                    <OptInSection packag={inputPackageType} packFunc={handleManualChange} />
                    <Convince />
                </div>
                <ContactSheet showContact={showContact} ref={contactSheetRef}  />
            </ScrollSpy>
        </>
    )
}
